import { TableHeaderType } from "~/models/types/TableHeaderType";
import { LABELS } from "~/resources/Labels";
import { SortTable } from "~/models/Comons";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface Prop {
    headers: TableHeaderType[];
    showActionsHeader: boolean;
    sortConfig: SortTable;
    handleSort: Function;
}

export const SIMPLTableHeader = ({
    headers,
    sortConfig,
    showActionsHeader,
    handleSort,
}: Prop) => {
    const arrowStyle = {
        opacity: 0.3,
        transition: 'opacity 0.2s ease',
    };

    const activeArrowStyle = {
        opacity: 1,
    };

    const headerClickableStyle = {
        cursor: 'pointer',
    };
    /**Allow user to use keyboard Enter */
    const handleKeyAction = (event: React.KeyboardEvent, action: () => void) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            action();
        }
    };

    return (
        <thead>
            <tr className="w-[1372px] h-[64px] top-[112px] left-[16px] gap-0 text-title&label">
                {headers.map((header, index) => (
                    <th
                        key={index}
                        className="pl-4 w-[1296px] h-[86px] pt-[16px] gap-[16px] text-title&label text-base"
                        style={headerClickableStyle}
                        onClick={() => header.sortable && handleSort(header.key)}
                        onKeyDown={(e) =>
                            header.sortable &&
                            handleKeyAction(e, () => handleSort(header.key))
                        }
                    >
                        <div className="flex items-center gap-2">
                            {header.label}
                            {header.sortable ? (
                                <span
                                    style={
                                        sortConfig.key === header.key
                                            ? activeArrowStyle
                                            : arrowStyle
                                    }
                                >
                                    {sortConfig.direction === LABELS.ASC ? (
                                        <ArrowUpwardIcon
                                            fontSize="small"
                                            className="w-[32px] h-[2px]"
                                        />
                                    ) : (
                                        <ArrowDownwardIcon
                                            fontSize="small"
                                            className="w-[32px] h-[32px]"
                                        />
                                    )}
                                </span>
                            ) : null}                                               
                        </div>
                    </th>
                ))}
            </tr>
            {showActionsHeader && (
                <tr>
                    <th key="tblActions">{LABELS.Actions}</th>
                </tr>
            )}
        </thead>
    );
};